import { i18n } from '@/plugins/i18n';

const { t } = i18n.global;

const useGetOptionContractStateChainLabel = (status: number) => {
  if (status > 0) {
    return t('option.contractState.ITM');
  } else {
    return t('option.contractState.OTM');
  }
};

export default useGetOptionContractStateChainLabel;
